module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10782/images/hubspot-academy-logo-color.svg"